module.exports = __webpack_public_path__ + "img/Pipeline_2.61e0cf0b.png";